export default "__VITE_ASSET__DBVMy1cR__"